import AppIcon from "../assets/app-icon.svg";

export const setToken = (token) => {
  localStorage.setItem("token", token);
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const getHeaders = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
};

export const setCurrentUser = (userData) => {
  localStorage.setItem("currentUser", JSON.stringify(userData));
};

export const getCurrentUser = () => {
  try {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    return currentUser;
  } catch (error) {
    console.log("Error getting current user", error);
    localStorage.removeItem("currentUser");
    window.location.reload();
  }
};

export const handleLogout = () => {
  localStorage.removeItem("currentUser");
  localStorage.removeItem("artistKey");
  localStorage.removeItem("token");
  localStorage.removeItem("code");
  localStorage.removeItem("invite");
  localStorage.removeItem("country");
  localStorage.removeItem("limited");
  localStorage.removeItem("loc");
  localStorage.removeItem("mapbox.eventData.uuid");
  window.location.href = "/";
};

export const getUIStage = () => {
  const hostname = window.location.hostname;
  if (hostname.includes("localhost")) {
    return "staging";
  } else if (hostname.includes("dev")) {
    return "dev";
  } else if (hostname.includes("192.")) {
    return "staging";
  } else if (hostname.includes("staging")) {
    return "staging";
  } else {
    return "prod";
  }
};

export const getPageTitle = () => {
  let title = "Notebook";
  if (getUIStage() !== "prod") {
    title = `[${getUIStage()}] ${title}`;
  }

  if (window.location.hostname.includes("localhost")) {
    title = `[localhost] ${title}`;
  }
  return title;
};

export function formatSeconds(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  const paddedSeconds = remainingSeconds.toString().padStart(2, "0");
  return `${minutes}:${paddedSeconds}`;
}

// ISO 8601 duration, the shape the MLC expects for Recording Playing Time
export function formatPlayingTime(seconds) {
  const total = Math.floor(Number(seconds) || 0);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const remainingSeconds = total % 60;
  const paddedMinutes = minutes.toString().padStart(2, "0");
  const paddedSeconds = remainingSeconds.toString().padStart(2, "0");
  return `PT${hours}H${paddedMinutes}M${paddedSeconds}S`;
}

export function getContentArtwork(content) {
  if (content) {
    return content.meta.cover || content.owner.meta.artwork || AppIcon;
  }
  return null;
}
